export const DEFAULT_MAX_OPTIONS_RENDERED = 200;

export function normalizeSearchText(value) {
    return String(value ?? '')
        .trim()
        .toLowerCase();
}

export function filterAndLimitOptions(options, searchValue, limit = DEFAULT_MAX_OPTIONS_RENDERED) {
    const search = normalizeSearchText(searchValue);
    if (!search) return options.slice(0, limit);
    return options.filter((opt) => opt.searchText.includes(search)).slice(0, limit);
}

/**
 * Groups item information rows into a map of externalSku -> Set(names).
 * @param {Array<{externalSku:string,name:string}>} itemInformationRows
 * @returns {Map<string, Set<string>>}
 */
export function groupItemInfoNamesByExternalSku(itemInformationRows) {
    const grouped = new Map();
    const rows = Array.isArray(itemInformationRows) ? itemInformationRows : [];

    for (const row of rows) {
        const externalSku = String(row?.externalSku ?? '');
        if (externalSku) {
            const name = String(row?.name ?? '');
            if (!grouped.has(externalSku)) grouped.set(externalSku, new Set());
            if (name) grouped.get(externalSku).add(name);
        }
    }

    return grouped;
}
